import { useState, useMemo } from "react";
import { useSearch } from "../../../hooks/search";
import { ListingWithDetails } from "../../../types";
import { ListingItemsList } from "../../ListingItemsList";
import { SearchWithFilter } from "../../Search/SearchWithFilter";
import "./ListingGrid.css";

type SearchableGridProps = {
  listingItems: ListingWithDetails[];
  onListingSelect: (item: ListingWithDetails | null) => void;
  selectedListing: ListingWithDetails | null;
  loading?: boolean;
  categories?: string[];
  handleAddClick: () => void;
};

export const SearchableGrid = ({
  listingItems,
  onListingSelect,
  selectedListing,
  loading = false,
  categories = [],
  handleAddClick,
}: SearchableGridProps) => {
  // STATE
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const searchItems = useSearch<ListingWithDetails>(listingItems, {
    name: 0.7,
    description: 0.3,
  });

  const searchedItems: ListingWithDetails[] = useMemo(() => {
    if (!searchTerm) return listingItems;
    const results = searchItems(searchTerm);
    const ret = results.map(
      (r: {
        item: ListingWithDetails;
        matches: any;
        score: number | undefined;
      }) => r.item
    );
    if (selectedCategory) {
      return ret.filter((item) => item.subType === selectedCategory);
    }
    return ret;
  }, [listingItems, searchTerm, searchItems, selectedCategory]);

  return (
    <div className="searchable-grid__container">
      <SearchWithFilter
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        categories={categories}
        handleAddClick={handleAddClick}
        showAddButton={!!handleAddClick}
        placeHolderText={"Search listings..."}
        allCategoriesOptionLabel={"All Categories"}
      />
      <div className="services-count">{searchedItems.length} results</div>
      <div className="tab-content-scrollable">
        <ListingItemsList
          items={searchedItems}
          selectedOffering={selectedListing}
          onOfferingSelect={onListingSelect}
          offeringMembers={[]}
          loading={loading}
        />
      </div>
    </div>
  );
};
